import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  default: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(4),
    borderRadius: spacing(16),
    flex: 1,
  },
}))
